import React from 'react';
import PropTypes from 'prop-types';

export default function Loading({ loadingMessage }) {
  return (
    <div className="loading is-fullwidth is-flex is-overlay">
      {loadingMessage && <div className="loading-message">{loadingMessage}</div>}
      <div className="loading-graphic-container">
        <div className="loading-graphic" />
      </div>
    </div>
  );
}
Loading.defaultProps = {
  loadingMessage: null,
};
Loading.propTypes = {
  loadingMessage: PropTypes.string,
};
